import Datepicker from 'vuejs-datepicker';
import { ru } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
import selectVocabulary from '@/utils/select_vocabulary';
import tableHeaderName from '@/utils/table_header_name';
import { mapState } from 'vuex';
import { required, minLength as _minLength, maxLength as _maxLength, requiredIf } from 'vuelidate/lib/validators';
import {
  MIN_LENGTH_STRING,
  MAX_LENGTH_STRING,
  notSpaceInBeginningStringformat,
  dateNotMoreCurrent,
  dateNotLessCurrent,
  validateUrl,
  endDateIsBefore } from '@/utils/input_utils';
import * as Api from '@/api';
import { checkAndConcatNewArray } from '@/utils/_function.js';

export default {
  name: 'ContentForm',
  props: {
    isDataSaving: {
      type: Boolean
    },
    formContent: {
      type: Object,
      default: () => ({
        proprietorId: null,
        essentialName: null,
        contractualName: null,
        contentType: null,
        releaseYearOn: null,
        productionCountry: null,
        priority: null,
        rightsTypes: null,
        lisenceStartAt: null,
        lisenceEndAt: null,
        externalId: null,
        legalLinks: []
      })
    },
    isAddLink: {
      type: Array,
      default: () => ([])
    },
    isNewContent: {
      type: Boolean,
      default: false
    },
    currentProprietor: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      ru: ru,
      companyList: null,
      isAddNewLink: true,
      countryOptions: [],
      contentId: null,
      isUnlimitedData: false,
      contentTypeOptions: selectVocabulary.contentTypeOptions,
      priorityOptions: selectVocabulary.priorityOptions,
      rightsTypeOptions: selectVocabulary.rightsTypeOptions,
      fields: tableHeaderName.linkAddFields
    };
  },
  validations() {
    const minLength = _minLength(MIN_LENGTH_STRING);
    const maxLength = _maxLength(MAX_LENGTH_STRING);
    return {
      formContent: {
        essentialName: {
          required,
          minLength,
          maxLength,
          notSpaceInBeginningStringformat
        },
        contractualName: {
          required,
          minLength,
          maxLength,
          notSpaceInBeginningStringformat
        },
        contentType: {
          required
        },
        productionCountry: {
          required
        },
        proprietorId: {
          required
        },
        priority: {
          required
        },
        rightsTypes: {
          required
        },
        releaseYearOn: {
          required,
          dateNotMoreCurrent
        },
        lisenceStartAt: {
          required,
          isBefore: endDateIsBefore('endedAt')
        },
        lisenceEndAt: {
          required: requiredIf(function() {
            return !this.isUnlimitedData;
          }),
          isBefore: dateNotLessCurrent
        },
        legalLinks: {
          $each: {
            url: {
              validateUrl
            },
            comment: {
              notSpaceInBeginningStringformat
            }
          }
        },
        externalId: {}
      }
    };
  },
  components: {
    Datepicker
  },
  watch: {
    isAddLink() {
      const l = this.isAddLink.find(item => {
        return item.fl === false;
      });

      if (l) {
        this.isAddNewLink = l.fl;
      } else {
        this.isAddNewLink = true;
      }
    },
    formContent: {
      handler: function() {
        this.$emit('updatingData', this.$props);
      },
      deep: true
    },
    isDataSaving(value) {
      if (value) {
        if (this.formContent &&
          this.formContent.legalLinks &&
          this.formContent.legalLinks.length) {
          this.formContent.legalLinks.forEach((currentValue, index, array) => {
            if (!currentValue.url) {
              this.isAddNewLink = true;
              array.splice(index, 1);
            }
          });
        }

        if (this.isUnlimitedData) {
          this.formContent.lisenceEndAt = null;
        }

        this.$v.$invalid ? this.$v.$touch() : this.$emit('savingData');
      }
    }
  },
  created() {
    this.contentId = this.$route.params.id;

    if (!this.formContent.lisenceEndAt && !this.isNewContent) {
      this.isUnlimitedData = true;
    }

    Api.getCountriesList()
      .then((response) => {
        response.data.map((item) => {
          this.countryOptions.push(item.attributes);
        });
      })
      .catch((error) => {
        if (error) {
          this.$rollbar.warning(error);
        }
        this.$toastr('error', this.$t('commonMessage.requestError'), 'Ошибка');
      });
  },
  computed: {
    ...mapState({
      authUser: state => state.authUser,
      proprietorsList(state) {
        return checkAndConcatNewArray(state.proprietorsListForFiler, this.currentProprietor);
      }
    })
  },
  methods: {
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: async(loading, search, vm) => {
      const param = {
        queryString: {
          page: 1,
          per_page: 100,
          fields: ['name', 'email'],
          not_only_own: false,
          search: { 'name': search.trim() }
        }
      };

      await vm.$store.dispatch('getProprietorsList', param);
      loading(false);
    },
    customFormatter(date) {
      return moment(date).format('YYYY');
    },
    addNewLink() {
      this.isAddLink.push({
        fl: false,
        error: false
      });

      this.formContent.legalLinks.push({
        date: new Date(),
        url: null,
        comment: null
      });
    },
    addLink(index) {
      if (!this.$v.formContent.legalLinks.$each[index].url.$model || this.$v.formContent.legalLinks.$each[index].$invalid) {
        this.isAddLink[index].error = true;
        return;
      }

      this.isAddNewLink = true;
      this.isAddLink[index].fl = true;
      this.isAddLink[index].error = null;
    },
    deleteLink(index) {
      this.formContent.legalLinks.splice(index, 1);
      this.isAddLink.splice(index, 1);
    }
  }
};
